export default defineNuxtPlugin(() => {
    const { public: { laravelApiBaseURL, laravelApiToken } } = useRuntimeConfig();

    const headers = reactive<HeadersInit>({
        'x-api-key': laravelApiToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    });

    const laravelApi = $fetch.create({
        baseURL: laravelApiBaseURL,
        headers,
    });

    return {
        provide: {
            laravelApi,
        },
    };
});